import Fact from './Fact.vue';

/**
  * Facts component
  *
  */
export default {
  name: 'facts',
  components: {Fact},
  data: () => ({
    facts: [],
  }),
  created() {
    this.facts = this.$children;
  }
};
